import React from 'react';

import { PrimitivesProvider } from 'node_modules/@change-corgi-ds-v2/primitives';

import { DSV2Link } from './components/DSV2Link';

type Props = { children: React.ReactNode };

export const DSV2PrimitivesProvider: React.FC<Props> = ({ children }: Props) => (
	<PrimitivesProvider primitives={{ a: DSV2Link }}>{children}</PrimitivesProvider>
);
